import { render, staticRenderFns } from "./UploadDocumentS.vue?vue&type=template&id=38104e20&scoped=true"
import script from "./UploadDocumentS.vue?vue&type=script&lang=js"
export * from "./UploadDocumentS.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentS.vue?vue&type=style&index=0&id=38104e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38104e20",
  null
  
)

export default component.exports